import { render, staticRenderFns } from "./AddHubBoosters.vue?vue&type=template&id=633f0642"
import script from "./AddHubBoosters.vue?vue&type=script&lang=js"
export * from "./AddHubBoosters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports